import type { FaireProductEntity } from "../../entity_types/product";

export const p_5acjffyjzf: FaireProductEntity = {
  token: "p_5acjffyjzf",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Hoop Earrings - 7167",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/d5c4e0cfbdeb20f865f0765ac247ba8247fa7d7386de5159fe2663982d20632d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe90953c64fe5d3fd56e454d190613045b58f90dd2894dabe03b1bf8d9f24974.jpeg",
    "https://cdn.faire.com/fastly/07eeab3bf1f3b40fa616bf454f393884078f2976bf8c2f298ca900271bb6637d.jpeg",
    "https://cdn.faire.com/fastly/6e63607e010403c4e1d89965043b70888164fcc3ae8ff4f6a3d43c0a57325bc6.jpeg",
    "https://cdn.faire.com/fastly/a780ce0d35629c6693fa84ad92afab9acbb86b6fe30e15191a2d21d7d74b5f28.jpeg",
    "https://cdn.faire.com/fastly/d3e831252ed5bfbfb9767e961a9f6a9afa789021e8c87c454f6ad1669b706c96.jpeg",
  ],
  priceDollars: 5.2,
  description:
    '18K Gold Dipped Stainless Steel Hoop Earrings.\nApprox. 0.9"L\n\n\n\nThese earrings are hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\n\n',
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:10.076Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
